import * as React from "react";
import { Component } from "react";

import {connect} from "react-redux";
import {IRootState} from "../../../store";
import DispatchProps from "../../../utils/DispatchProps";
import ApiService from "../../ApiService";

import H from "history";
import {urlForTimelineItem, OnboardTimelineState, OnboardTimelineItem} from "./OnboardTimeline";
import { Redirect } from "react-router";
import School from "../../../models/School";

interface OnboardHomePageProps {
    tenantId: string;
    schoolCode: string;

    userIsCdbEmployee: boolean;
    
    apiService: ApiService;
    history: H.History;
}

interface OnboardHomePageState {
    wizardPage?: string
    school?: School;
}

class OnboardHomePage extends Component<OnboardHomePageProps & DispatchProps,OnboardHomePageState> {

    constructor(props: OnboardHomePageProps & DispatchProps) {
        super(props);

        this.state = {
            wizardPage: undefined
        };
    }

    async componentDidMount(): Promise<void> {
        if (!this.state.school) {
            const school = await this.props.apiService.getSchool(this.props.tenantId, this.props.schoolCode);

            this.setState({
                school
            })           
        }

        if (this.state.school) {
            this.updateWizardPage();
        }
    }

    async componentDidUpdate(prevProps: Readonly<OnboardHomePageProps & DispatchProps>, prevState: any): Promise<void> {
        if (this.state.school && this.state.school !== prevState.school) {
            this.updateWizardPage();
        }
    }
    
    private updateWizardPage()
    {
        let timeline: OnboardTimelineItem[] = OnboardTimelineState.getCurrentOnboardTimeline(this.state.school?.onboardStatus, this.state.school?.license)

        if(!timeline || timeline.length === 0) {
            return;
        }
        
        const firstIncompleteItem = timeline.filter(ti => !ti.completed)[0];
        const itemToRedirectTo = firstIncompleteItem || timeline[0];
        
        if(itemToRedirectTo)
        {
            this.setState({
                wizardPage: urlForTimelineItem(this.props.tenantId, this.props.schoolCode, itemToRedirectTo)
            });
        }
    }

    
    public render(): JSX.Element {
        if (this.state.wizardPage) {
            return <Redirect to={this.state.wizardPage} />
        } else {
            return <div>No Onboarding State Available</div>;
        }
    }
}

export default connect(
    (state: IRootState,ownProps: any): OnboardHomePageProps => {

        const tenantId = ownProps.match.params.tenantId;
        const schoolCode = ownProps.match.params.schoolCode;
        
        return {
            tenantId,
            schoolCode,
            userIsCdbEmployee: state.auth.userIsCdbEmployee,

            apiService: state.auth.apiService,
            history: ownProps.history
        };

    }
)(OnboardHomePage)